import React, { useEffect, useRef, useState } from "react";
import { Box, Grid, Typography,Select,MenuItem } from "@mui/material";
import {FaRegCommentDots} from 'react-icons/fa';
import {AiOutlineInfoCircle} from 'react-icons/ai';
import { useLocation, useNavigate,useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import examActions from "../Redux/exam/actions";
import Cookies from "js-cookie";
import { store } from "../Redux/store";
import { handleEncodeJson } from "../utils/encodeDecodeJson";
import RemainingTimeModal from "../components/liveTest/remainingTimeModal";
import commonActions from "../Redux/common/actions";
import profileImage from "../assets/images/profile.png";
import signatureImage from "../assets/images/signature.png";
import feedbackActions from "../Redux/feedback/actions";
import useFetchCandidateTokenDetails from "../hooks/useFetchCandidateTokenDetails";
import { initProctor, startProctoring, stopProctoring } from "../libs/liteProctoring/liteProctorService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { auditLog } from "../utils/auditLog";
import { convertMs, getCurrentServerTime} from "../utils/commonFunctions"; 
import {
  DecryptObjectFunction,
  EncryptObjectFunction,
} from "../utils/cryptoFunction";
import { BsChatLeftDots } from "react-icons/bs";
import { Feedback } from "@mui/icons-material";

export default function Header() {
  const dispatch = useDispatch();
  const location = useLocation();
  const isSummaryPage = location.pathname.includes("summary");
  const navigate = useNavigate();
   const [value, setValue] = useState(1);
    const [decryptedParams, setDecryptedParams] = useState({});
   const [selectedLanguage, setSelectedlanguage] = useState(null);
  const [candidateTokenDetails, setCandidateTokenDetails] = useState(null);
  const [showNotification, setShowNotification] = useState(false);
  const [currentStatus, setCurrentStatus] = useState(null);
  // heartbeat optimization///////
  const lastServerTimeRef = useRef(null);
  const lastClientSyncTimeRef = useRef(null);
  // const videoRef = useRef(null);
  const [alerts, setAlerts] = useState([]);
  const [status, setStatus] = useState("idle");
  const isFeedback = location?.pathname?.split("/")[2] === "feedback";
  const isSample = location?.pathname?.split("/")[2] === "sample-test";
  const candidateData = JSON.parse(sessionStorage.getItem("candidate_details"));
  const isVenue = sessionStorage.getItem("venue");
  const isForceLogout = candidateTokenDetails?.configuration?.forcedLogout;
const [searchParams] = useSearchParams();
  const { heartBeat, projectDetails, questionsAndOptions,instructions } = useSelector(
    (state) => state.examReducer
  );
  const encryptedParams = searchParams.get("qNo");
 const imageSize = decryptedParams?.img ?? "L";
  const language = decryptedParams?.lang || "english";
  const currentSrNo = decryptedParams?.SrNo;
  useEffect(() => {
    if (language) setSelectedlanguage(language);
  }, [language]);
  useEffect(() => {
      if (encryptedParams) {
        let decrypted = DecryptObjectFunction(encryptedParams);
        setDecryptedParams(decrypted);
      } else {
        
      }
    }, [encryptedParams]);
  const handleInstruction = () => {
    dispatch({
      type: commonActions.SET_SHOW_MODAL,
      payload: { show: true, type: null, method: "I", data: null },
    });
    auditLog({
      data: {
        RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
        RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
        Activity: "User Opened Instrucion Popup in Live Test",
      },
      dispatch,
      heartBeat,
    });
  };
  const isLateLoginAllowed =
    candidateTokenDetails?.configuration?.lateLoginAllowed;
  const isSection = Object.values(
    questionsAndOptions?.questionsList || {}
  ).every((res) => "section" in res);
  const isStartExamBetweenSpecifiedTime =
    candidateTokenDetails?.configuration?.startExamBetweenSpecifiedTime;
  const isMultidayExamWithSection =
    isSection && isStartExamBetweenSpecifiedTime;
  const isMaximumLoginAttempts =
    candidateTokenDetails?.configuration?.maximumLoginAttempts === null;
  const examStartTime = sessionStorage.getItem("examStartTime");

  const [timeToStart, setTimeToStart] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const [triggeredMinutes, setTriggeredMinutes] = useState([]);
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  // let lastAlert = { message: null, timestamp: 0 };
  // const ALERT_COOLDOWN = 10000; // 5 sec
  useEffect(() => {
    if (!instructions || Array.isArray(instructions)) {
      dispatch({ type: examActions.GET_INSTRUCTIONS });
    }
    store.dispatch({ type: examActions.GET_HEART_BEAT });
  }, []);
  useEffect(() => {
   if (!selectedLanguage && instructions?.instructions?.[0]?.language) {
     setSelectedlanguage(language || instructions.instructions[0].language);
   }
 }, [instructions?.instructions]);
  useEffect(() => {
    if (!candidateTokenDetails?.configuration?.startTime) return;

    const startTime = new Date(candidateTokenDetails.configuration.startTime);

    const updateTimeToStart = () => {
      const now = new Date(heartBeat?.data);
      const difference = startTime - now;

      if (difference > 0) {
        const hours = Math.floor(difference / (1000 * 60 * 60));
        const minutes = Math.floor(
          (difference % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);
        setTimeToStart({ hours, minutes, seconds });
      } else {
        if (!showNotification && now < startTime) {
          dispatch({
            type: commonActions.SET_SHOW_MODAL,
            payload: { show: true, type: null, method: "N", data: null },
          });
          setShowNotification(true);
        }
        setTimeToStart({ hours: 0, minutes: 0, seconds: 0 });
      }
    };
    updateTimeToStart();
    const interval = setInterval(updateTimeToStart, 1000);

    return () => clearInterval(interval);
  }, [candidateTokenDetails, heartBeat]);

  useEffect(() => {
    if (!heartBeat?.data) return;
    // server authorize time 
    lastServerTimeRef.current = new Date(heartBeat.data);
    // client Time Stamp sync 
    lastClientSyncTimeRef.current = Date.now();
  }, [heartBeat]);

  
  useEffect(() => {
  if (!candidateTokenDetails?.configuration) return;
  const startTime = Date.parse(
    isStartExamBetweenSpecifiedTime
      ? examStartTime
      : candidateTokenDetails.configuration.startTime
  );

  const endTime = Date.parse(candidateTokenDetails.configuration.endTime);

  const updateTimer = () => {
    const currentTime = getCurrentServerTime(lastServerTimeRef.current, lastClientSyncTimeRef.current);
    if (!currentTime) return;

    let examRemainingMs;
    if (currentTime < startTime) {
      // ⏳ Exam not started yet
      examRemainingMs = endTime - startTime;
    } else if (currentTime >= endTime) {
      // Exam finished
      examRemainingMs = 0;
    } else {
      // Exam running
      examRemainingMs = endTime - currentTime;
    }

    window.dispatchEvent(
      new CustomEvent("syncedClockTick", {
        detail: { nowMs: currentTime.getTime(), examRemainingMs },
      })
    );

    setTimeLeft(convertMs(examRemainingMs));
  };
  // Run once immediately
  updateTimer();
  // Run every second for smooth UI
  const interval = setInterval(updateTimer, 1000);
  return () => clearInterval(interval);
}, [candidateTokenDetails]);


  useFetchCandidateTokenDetails({ setCandidateTokenDetails });

  useEffect(() => {
    if (!projectDetails || Array.isArray(projectDetails)) {
      dispatch({
        type: examActions.GET_PROJECT_DETAILS,
        payload: {
          data: {
            project: `${Cookies.get("test_engine_project")}`,
          },
        },
      });
    }
  }, []);

  useEffect(() => {
    const notificationTimes =
      candidateTokenDetails?.configuration?.reminders || [];
    if (
      candidateTokenDetails?.configuration &&
      candidateTokenDetails?.configuration?.reminders &&
      timeLeft?.hours === 0 &&
      timeLeft?.seconds === 0 &&
      notificationTimes.includes(timeLeft?.minutes) &&
      !triggeredMinutes.includes(timeLeft?.minutes)
    ) {
      dispatch({
        type: commonActions.SET_ALERT,
        payload: {
          status: "alert",
          show: true,
          message: `You have ${timeLeft?.minutes} minutes left to complete your exam. Please ensure you review your answers and submit your exam before time runs out.`,
        },
      });
      setTimeout(() => {
        dispatch({
          type: commonActions.SET_ALERT,
          payload: {
            status: null,
            show: false,
            message: null,
          },
        });
      }, 10000);
      setTriggeredMinutes((prev) => [...prev, timeLeft?.minutes]);
    }
  }, [timeLeft, candidateTokenDetails?.configuration?.reminders]);

  useEffect(() => {
    const notificationTimes =
      candidateTokenDetails?.configuration?.reminders || [];
    if (
      candidateTokenDetails?.configuration &&
      candidateTokenDetails?.configuration?.reminders &&
      timeToStart?.hours === 0 &&
      timeToStart?.seconds === 0 &&
      notificationTimes.includes(timeToStart?.minutes) &&
      !triggeredMinutes.includes(timeToStart?.minutes)
    ) {
      dispatch({
        type: commonActions.SET_ALERT,
        payload: {
          status: "alert",
          show: true,
          message:
            notificationTimes.length === 0 &&
              timeToStart?.hours === 0 &&
              timeToStart?.minutes === 0
              ? `Please start your exam now!`
              : `Exam starts in ${timeToStart?.minutes} minutes`,
        },
      });
      setTimeout(() => {
        dispatch({
          type: commonActions.SET_ALERT,
          payload: {
            status: null,
            show: false,
            message: null,
          },
        });
      }, 10000);
      setTriggeredMinutes((prev) => [...prev, timeToStart?.minutes]);
    }
  }, [timeToStart, candidateTokenDetails?.configuration?.reminders]);

 useEffect(() => {
  let stream;

  const startProctoring = async () => {
    try {
      const videoEl = document.getElementById("cameraScreen");
      if (!videoEl) return;

      stream = await navigator.mediaDevices.getUserMedia({ video: true });
      videoEl.srcObject = stream;

      // Ensure metadata is loaded before play
      videoEl.onloadedmetadata = async () => {
        try {
          await videoEl.play();
        } catch (err) {
          console.error("Video play failed:", err);
        }
      };
    } catch (error) {
      console.error("Error starting proctoring:", error);
    }
  };

  startProctoring();

  return () => {
    // ✅ Cleanup: stop camera when component unmounts
    if (stream) {
      stream.getTracks().forEach(track => track.stop());
    }
  };
}, [candidateTokenDetails]);

 const handleLanguageChange = async (language, newValue) => {
    setValue(newValue);
    setSelectedlanguage(language);
    auditLog({
      data: {
        RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
        RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
        Activity: "User selected in Live Test Language change",
        IPaddress: "",
      },
      dispatch,
      heartBeat,
    });
    let encodedData, queryParams, encryptedParans;
    queryParams = {
      SrNo: currentSrNo,
      lang: language,
      img: imageSize,
    };
    let formData = {
      imageSize: `${imageSize}`,
      action:
        currentStatus === "marked"
          ? "mark"
          : currentStatus === "answered_and_marked"
            ? "mark"
            : "next",
      currentSrNo: currentSrNo,
      nextSrNo: currentSrNo,
      selectedAnswer: questionsAndOptions?.questionData?.selectedAnswer,
      language: `${language}`,
    };
    encodedData = await handleEncodeJson({ encodeJSON: formData });
    encryptedParans = EncryptObjectFunction(queryParams);
    dispatch({
      type: examActions.GET_SUBMIT_ANSWER,
      payload: {
        data: encodedData,
        navigate: (path) => navigate(`${path}?qNo=${encryptedParans}`),
      },
    });
  };
  const handleFeedback = async () => {
    const formData = {
      imageSize: "L",
      language: "english",
    };
    const encodedData = await handleEncodeJson({ encodeJSON: formData });
    dispatch({
      type: feedbackActions.GET_FEEDBACK_QUESTIONS,
      payload: {
        data: encodedData,
        formData: formData,
        navigate: navigate,
      },
    });
  };

  useEffect(() => {
    // If examEndTime is missing, force re-login to prevent false auto-submit from an invalid fallback date.
    if (!sessionStorage.getItem("candidate_exam_details")) {
      Cookies.remove("test_engine_token");
      const project = Cookies.get("test_engine_project");
      sessionStorage.clear();
      navigate(project ? `/${project}/login` : "/login", { replace: true });
      return;
    }

    const endTime = candidateTokenDetails?.configuration?.endTime;

    if (heartBeat?.data > endTime) {
      if (projectDetails?.mockMode) {
        dispatch({ type: examActions.END_EXAM, payload: { mockMode: true } });
      } else {
        let isEnded = sessionStorage.getItem("examEnded");
        const isInFeedback = sessionStorage.getItem('isInFeedback')
        if (isInFeedback) {
          const currentParams = location.search; // includes ?...

          navigate(
            `/${Cookies.get("test_engine_project")}/feedback${currentParams}`
          );
        } else if (!isEnded) {
          auditLog({
            data: {
              RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
              RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
              Activity: "Exam Auto Submitted(Exam Screen)",
              IPaddress: "",
            },
            dispatch,
            heartBeat,
            debugInfo: {
              endTime,
              heartbeatData: heartBeat?.data,
              isForceLogout,
            },
          });
          navigate("/summary");
          sessionStorage.setItem("examEnded", true);
        }
      }
    }
  }, [heartBeat]);

  let venue = sessionStorage.getItem("venue");
  let isMock = projectDetails?.mockMode;
  const proctoringEnabled = candidateTokenDetails?.configuration?.proctoringEnabled === true;


  return (
    <>
      <ToastContainer />
      <Grid container lg={12} md={12} sm={12} xs={12} sx={{
    height: { xs: "auto", sm: "auto", md: "64px", lg: "64px" }
      }}
       p={1} pl={3} pr={3} style={{backgroundColor:"#f0f0fb",borderBottom: "1px solid #e0e0e0",flexWrap:"nowrap",justifyContent:"space-between"
   }}>
   <Grid  sx={{display:"flex" , flexWrap:{xs:"nowrap"} ,justifyContent:{xs:"center",sm:"center",md:"space-between"}}}>
        <Grid>
        {proctoringEnabled && !isFeedback && (
          <Grid> 
            <video
            id="cameraScreen"
            style={{
              marginRight: "8px",
              width: "60px",
              height: "40px",
              // borderRadius: "8px",
              background: "#808080",
              transform: "scaleX(-1)",
            }}
            muted
            playsInline
          />
            </Grid>
              )}

        </Grid>
        <Grid>
        {!isFeedback && (
          <Grid item md={0.5} lg={0.5} sm={12} xs={12} >
            <Grid sx={{ display: "flex", alignItems: "center"}}>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                {!isFeedback && (
                  <Box
                    component={"img"}
                    src={
                      venue && !isMock
                        ? `${sessionStorage.getItem("api_url")}/${candidateTokenDetails?.user?.photoPath
                        }`
                        : projectDetails?.mockMode
                          ? profileImage
                          : candidateTokenDetails?.user?.photoPath
                    }
                    alt="profile"
                    sx={{ height: "50px", width: "50px" , objectFit:'fill'}}
                  />
                )}
              </Box>
            </Grid>
            {/* <Box sx={{ width: "48px", height: "18px", background: "#fff" }}>
              {!isFeedback && (
                <Box
                  component={"img"}
                  src={
                    venue && !isMock
                      ? `${sessionStorage.getItem("api_url")}/${candidateTokenDetails?.user?.signaturePath
                      }`
                      : projectDetails?.mockMode
                        ? signatureImage
                        : candidateTokenDetails?.user?.signaturePath
                  }
                  alt="signature"
                  sx={{ height: "18px", width: "48px" }}
                />
              )}
            </Box> */}
          </Grid>
        )}</Grid>
        </Grid>
        <Grid item md={3} lg={3} sm={12} xs={12} p={1} pl={{sm:"40%",xs:"40%",md:0}} sx={{ display:{xs:"none",md:"block"}, height:"65px",alignContent:"center",justifyContent:{xs:"center",sm:"center",md:"flex-start"}}}>
          
          <Typography sx={{ fontSize: "14px" }}>
            <b>
              {isFeedback
                ? candidateData?.candidateName
                : projectDetails?.mockMode
                ? candidateTokenDetails?.candidate?.candidateName
                : candidateTokenDetails?.user?.candidateName}
            </b>
            {/* {projectDetails?.mockMode
              ? "12345"
              : candidateTokenDetails?.user?.rollNo || candidateData?.rollNo} */}
           
            {/* {!projectDetails?.mockMode && (
              <>
                {candidateTokenDetails?.user?.scribeRequired && (
                  <span style={{ color: "rgba(63, 65, 209, 1)" }}>
                    (Scribe Allowed)
                  </span>
                )}
              </>
            )} */}
          </Typography>
          <Typography sx={{ fontSize: "14px",color:"gray" }}>(
            {projectDetails?.mockMode
              ? "12345"
              : candidateTokenDetails?.user?.rollNo || candidateData?.rollNo})
            {/* {candidateTokenDetails?.configuration?.venueName} */}
          </Typography>
          {/* <Typography
            sx={{
              color: isVenue
                ? heartBeat?.code === "OK"
                  ? "rgba(84, 179, 55, 1)"
                  : "rgba(234, 104, 58, 1)"
                : isOnline
                  ? "rgba(84, 179, 55, 1)"
                  : "rgba(234, 104, 58, 1)",

              display: "flex",
              alignItems: "center",
              fontWeight: 500,
              lineHeight: 0.5,
            }}
          >
            <span
              style={{
                fontSize: "50px",
                fontWeight: "bold",
                paddingBottom: "4px",
              }}
            >
              •
            </span>
            &nbsp;{isOnline ? "Connected" : "Disconnected"}
          </Typography> */}
        </Grid>
        <Grid
          item
          md={4.6}
          lg={4.6}
          sm={12}
          xs={12}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          pr={{sx:0, xs:0, md:6 , lg:6}}
          pb={{sx:0, xs:0, md:2 , lg:2}}
          ml={{sx:0, xs:0, md:-10 , lg:-10}}
          mr={{sx:0, xs:0, md:11 , lg:11}}
        >
          <Typography
            sx={{
              fontSize: {xs:"12px",md:"20px"},
              fontWeight: "bold",
              textTransform: "uppercase",
            }}
          >
            {isFeedback
              ? "Feedback"
              : isSample
                ? "Sample Test"
                : candidateTokenDetails?.configuration?.courseName}
          </Typography>
        </Grid>
        <Grid
          item
          md={2.4}
          lg={2.4}
          sm={12}
          xs={12}
          display={"flex"}
          flexDirection={"column"}
          alignItems= {{ xs: "center", sm: "center", md: "flex-end", lg: "flex-end" }}
          pt={1}
          pr={0}
        >
          {!isFeedback && !isSample ? (
            <>
      {/* Buttons row */}
      <Box sx={{ display: "flex", gap: 1, mb: 1 }}>
        {/* <Box sx={{ position: "relative", display: "inline-flex" }}>
  
  <Box
    sx={{
      background: "white",
      borderRadius: "6px",
      width: "40px",
      height: "40px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
      cursor: "pointer",
      border: "1px solid #3F41D1",
    }}
    onClick={()=>{localStorage.setItem("chatboat",true)}}
  >
    <BsChatLeftDots color="#3F41D1" size={20} />
  </Box>


  <Box
    sx={{
      position: "absolute",
      top: "-8px",
      left: "-8px",
      background: "#3F41D1",
      color: "white",
      fontSize: "12px",
      fontWeight: "bold",
      borderRadius: "50%",
      width: "18px",
      height: "18px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "0 1px 4px rgba(0,0,0,0.2)",
    }}
  >
    1
  </Box>
</Box> */}

      {/* Info Icon */}
      {!isSummaryPage && ( 
        <Box
        sx={{
          background: "white",
          borderRadius: "6px",
          width: "40px",
          height: "40px",
          display: {xs:"none",md:"flex"},
          alignItems: "center",
          flexWrap:"wrap",
          justifyContent: "center",
          boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
          cursor: "pointer",
          border:"1px solid #3F41D1"
        }}
      >
        <AiOutlineInfoCircle color="#3F41D1" size={20} 
        onClick={handleInstruction}
        />
      </Box>)}

      {/* Language Dropdown */}
     {!isSummaryPage && ( <Select
        size="small"
                    label=""
                    onChange={(event) =>
                      handleLanguageChange(event.target.value, 0)
                    }
        sx={{
          display:{xs:"none",md:"block"},
          height: "40px",
          fontSize: "13px",
          background: "white",
          borderRadius: "6px",
          border:"1px solid #3F41D1"
        }}
           value={language || selectedLanguage}
      >
       {candidateTokenDetails?.configuration?.languages.map(
                      (language, index) => (
                        <MenuItem
                          sx={{ textTransform: "capitalize" }}
                          key={index}
                          value={language}
                        >
                          {language.charAt(0).toUpperCase() + language.slice(1)}
                        </MenuItem>
                      )
                    )}
      </Select>)}

      {/* Remaining Time */}
      <Grid
      sx={{
      position: "relative",
      background: "white",
      borderRadius: "8px",
      boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
      display: "flex",
      alignItems: "center",   
      justifyContent: "center",
      height: {xs:"35px",md:"40px"},         
      px: 2,                  
      minWidth: "120px",
      // border:"1px solid rgba(63,65,209,1)", 
      border:"1px solid black"     // 👈 thoda fixed width jisse balance lage
    
  }}
>
  <Typography fontSize="12px" sx={{ mr: 1,position: "absolute",marginTop:"-38px",lineHeight: 0.5,fontWeight:"700",backgroundColor: "white", }}>
    Remaining Time
  </Typography>
  <Typography fontSize="14px" fontWeight="bold">
    {String(timeLeft?.hours).padStart(2, "0")}:
    {String(timeLeft?.minutes).padStart(2, "0")}:
    {String(timeLeft?.seconds).padStart(2, "0")}
  </Typography>
</Grid>

      </Box>
    </>
             
            
          ) : isSample ? (
            <>
              {/* <Typography
                style={{
                  fontSize: "14px",
                  fontWeight: 400,
                  lineHeight: "15.4px",
                }}
              >
                <b>Exam Starts in</b>
              </Typography>
              <Typography style={{ fontSize: "20px" }}>
                <b>
                  {String(timeToStart?.hours).padStart(2, "0")}:
                  {String(timeToStart?.minutes).padStart(2, "0")}:
                  {String(timeToStart?.seconds).padStart(2, "0")}
                </b>
              </Typography> */}
            </>
          ) : null}
        </Grid>
      </Grid>
      {/* <RemainingTimeModal
        endExamMinutes={0}
        startExamMinutes={timeToStart?.minutes}
      /> */}
    </>
  );
}
